export default __webpack_public_path__ + "static/media/education-10.655c0931.svg";